import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-upload-complete-dialogue',
  templateUrl: './upload-complete-dialogue.component.html',
  styleUrls: ['./upload-complete-dialogue.component.css']
})
export class UploadCompleteDialogueComponent implements OnInit {

  @Input() name: string = '';
  @Input() message: string = '';
  @Input() type: string = '';
  @Input() jobId: string = '';

  constructor(private router: Router) { }

  ngOnInit() {
  }

  redirect() {
    console.log('redirect');
    this.router.navigate(["/AdminPanel/image-upload-verifier"], {
      queryParams: { criteria: this.type, job_id: this.jobId },
    });
  }

}
